module.exports = __webpack_public_path__ + "pc/img/02_img_02.28577e7d.png";